import React, { useState, useEffect } from "react";
import AnimatedLinePath from "./common/AnimatedLinePath";
import { deriveLineFunction } from "./common/utils";


const LinePlot = ({ data, xScale, yScale, color }) => {
    const [toggle, setToggle] = useState(false);
    // const line = deriveLineFunction(xScale, yScale);
    //console.log({ line })

    useEffect(() => {
        setTimeout(() => {
            setToggle(true);
        });

    }, []);

    return (
        <g data-testid="AreaDensity">
            <AnimatedLinePath
                data={data}
                toggle={toggle}
                xScale={xScale}
                yScale={yScale}
            />
        </g>
    )


}

export default LinePlot;
